// toggle visibility of a password input
const passwordToggle = () => {
  const toggleEls = document.querySelectorAll<HTMLButtonElement>('[data-password-toggle]');

  if (!toggleEls.length) return;

  toggleEls.forEach((toggleEl) => {
    toggleEl.addEventListener('click', () => {
      const targetId = toggleEl.dataset.target;
      if (!targetId) return;

      const inputEl = document.getElementById(targetId) as HTMLInputElement | null;
      if (!inputEl) return;

      const isVisible = inputEl.type === 'text';
      inputEl.type = isVisible ? 'password' : 'text';
      toggleEl.classList.toggle('is-active', !isVisible);
      toggleEl.setAttribute('aria-pressed', String(!isVisible));
      toggleEl.setAttribute('aria-label', isVisible ? 'パスワードを表示' : 'パスワードを非表示');
    });
  });
};

export default passwordToggle;
